import { Action } from '@ngrx/store';
import { ProjectResponse } from '../projects/project';
import { ReportFilters } from './report-filters/ReportFilters';
import { StatsResponse } from '../stats/stats.model';

export const GET_REPORT_PROJECTS = 'GET_REPORT_PROJECTS';
export const GET_REPORT_PROJECTS_SUCCESS = 'GET_REPORT_PROJECTS_SUCCESS';
export const GET_REPORT_PROJECTS_FAILURE = 'GET_REPORT_PROJECTS_FAILURE';
export const SET_REPORT_FILTERS = 'SET_REPORT_FILTERS';

export const GET_REPORT_STATS = 'GET_REPORT_STATS';
export const GET_REPORT_STATS_SUCCESS = 'GET_REPORT_STATS_SUCCESS';
export const GET_REPORT_STATS_FAILURE = 'GET_REPORT_STATS_FAILURE';

export const REFRESH_REPORT_STATS_REQUEST = 'REFRESH_REPORT_STATS_REQUEST';
export const REFRESH_REPORT_STATS = 'REFRESH_REPORT_STATS';
export const CANCEL_REFRESH_REPORT_STATS = 'REFRESH_REPORT_STATS_CANCEL';

export class GetReportProjectsAction implements Action {
  readonly type = GET_REPORT_PROJECTS;

  constructor() {}
}

export class GetReportProjectsFailureAction implements Action {
  readonly type = GET_REPORT_PROJECTS_FAILURE;

  constructor(public payload: any) {}
}

export class GetReportProjectsSuccessAction implements Action {
  readonly type = GET_REPORT_PROJECTS_SUCCESS;

  constructor(public payload: ProjectResponse[]) {}
}

export class GetReportStatsAction implements Action {
  readonly type = GET_REPORT_STATS;

  constructor() {}
}

export class GetReportStatsFailureAction implements Action {
  readonly type = GET_REPORT_STATS_FAILURE;

  constructor(public payload: any) {}
}

export class GetReportStatsSuccessAction implements Action {
  readonly type = GET_REPORT_STATS_SUCCESS;

  constructor(public payload: StatsResponse) {}
}

export class SetReportFiltersAction implements Action {
  readonly type = SET_REPORT_FILTERS;

  constructor(public payload: ReportFilters) {}
}

export class RefreshReportStatsAction implements Action {
  readonly type = REFRESH_REPORT_STATS;

  constructor() {}
}

export class CancelRefreshReportStatsAction implements Action {
  readonly type = CANCEL_REFRESH_REPORT_STATS;

  constructor() {}
}

export class RefreshReportStatsRequestAction implements Action {
  readonly type = REFRESH_REPORT_STATS_REQUEST;

  constructor(public timeInSeconds: number) {}
}

export type ReportsAction =
  | GetReportProjectsAction
  | GetReportProjectsSuccessAction
  | GetReportProjectsFailureAction
  | GetReportStatsAction
  | GetReportStatsSuccessAction
  | GetReportStatsFailureAction
  | SetReportFiltersAction
  | RefreshReportStatsAction
  | RefreshReportStatsRequestAction
  | CancelRefreshReportStatsAction;
